<template>
  <div class="fillheight">
    <v-sheet class="fillheight overflow-hidden">
      <base-serve-table ref="table" v-model="form_map.layers" :api="api" :headers="headers" :params="params"
        :defaultParams="default_params" use-grid use-scroll-load use-top use-selected multi-select>
        <template #top-append-right>
          <v-text-field v-model="params.search" clearable dense hide-details outlined placeholder="Tìm kiếm theo tên"
            prepend-inner-icon="mdi-magnify" single-line />
        </template>
        <template #top-right>
          <div class="mr-1 ml-1 d-flex align-center">
            <base-button className="mr-1" @click="onPreview(form_map.layers)" outlined
              :disabled="form_map.layers.length < 1">
              Xem trước
            </base-button>
            <base-button
                className="ml-1 mr-2"
                @click="showShareDialog(form_map.layers)"
                outlined
                :disabled="form_map.layers.length < 1"
              >
                Chia sẻ
              </base-button>
            <base-button type-action="create" @click="onCreateItem()"></base-button>
          </div>
        </template>
        <template #grid-item="{ item }">
          <div class="d-flex pt-2">
            <div class="btn-group">
              <!-- <base-button class="text-none" text @click.stop="showShareDialog([item])" icon tooltip="Chia sẻ">
              <v-icon>mdi-share-variant</v-icon>
            </base-button> -->
              <base-button icon @click="onPreview([item])" :tooltip="$t('layer.action.preview')">
                <v-icon>mdi-eye</v-icon>
              </base-button>
              <base-button icon @click="onGotoDetail(item)" :tooltip="$t('workspace.setting')">
                <v-icon>mdi-cog</v-icon>
              </base-button>
              <!-- <base-button v-if="!item.home_public" icon @click="onPublicData(item)" :tooltip="'Công khai dữ liệu'">
                <v-icon>mdi-web</v-icon>
              </base-button>
              <base-button v-else icon @click="onPublicData(item)" :tooltip="'Bỏ công khai dữ liệu'">
                <v-icon>mdi-blur-off</v-icon>
              </base-button> -->

              <base-button type-action="delete" class="text-none" icon @click.stop="onDeleteItem(item)"
                v-if="checkAccess('layergroup.delete', item)">
              </base-button>
            </div>
          </div>
          <layer-group-item :value="item" :workspace="workspace">
          </layer-group-item>
        </template>
      </base-serve-table>
    </v-sheet>
    <LayerGroupDetail ref="dialog_detail" @reset="onReset" />
    <ShareDialog :typeLayer="'map_ids'" ref="shareDialog" />
  </div>
</template>

<script>
import LayerGroupItem from './layer-group-item.vue'
import { API_LAYERGROUP, API_LAYER } from '@api'
import { ConfirmBuilder } from '@utils'
import { mapGetters } from 'vuex'
import { EDIT_TYPE } from '@constant'
import LayerGroupDetail from './layer-group-detail.vue'
import ShareDialog from '../share/share-dialog.vue'

export default {
  mixins: [],
  components: {
    LayerGroupItem,
    LayerGroupDetail,
    ShareDialog
  },
  props: {
    id: [String, Number],
    workspace: { type: Object, default: () => ({}) },
  },
  data: (vm) => ({
    form_map: {
      layers: [],
    },
    default_params: {
      workspace_id: vm.id,
    },
    params: { search: '', inactive: null },
    menus: [
      {
        type: 'update',
        handler: (item) => vm.onUpdateItem(item),
        disabled: (item) => !vm.checkAccess('workspace.update', item),
      },
      {
        type: 'delete',
        handler: (item) => vm.onDeleteItem(item),
        disabled: (item) => !vm.checkAccess('workspace.delete', item),
      },
    ],
    headers: [
      {
        text: 'Tên hiển thị',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        text: 'Ngày tạo',
        align: 'start',
        sortable: true,
        value: 'created_at',
      },
      {
        text: 'Ngày cập nhật',
        align: 'start',
        sortable: true,
        value: 'updated_at',
      },
      {
        trans: 'field.action',
        value: 'action',
        sortable: false,
        width: '150px',
        align: 'center',
      },
    ],
    loading: false,
    resource_headers: [
      {
        trans: 'datastore.layer.name',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        trans: 'datastore.layer.action',
        align: 'start',
        sortable: false,
        value: 'action',
      },
    ],
    resource_default_params: {},
    resource_params: { search: '', inactive: null },
  }),
  watch: {},
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
    api() {
      return API_LAYERGROUP
    },
  },
  created() { },
  mounted() { },
  methods: {
    onGotoDetail(item) {
      this.$refs.dialog_detail.open(item, EDIT_TYPE.UPDATE)
    },
    showShareDialog(item){
      this.$refs.shareDialog.open(item)
    },
    async onDeleteItem(item) {
      let confirm = new ConfirmBuilder()
      confirm
        .addMessage('confirm.delete-name')
        .setTitle('confirm.title')
        .setOption({
          params: { name: item.username },
          color: 'error',
        })
        .setType('delete')
      if (await confirm.confirm()) {
        const result = await this.api.destroy(item.id, item)
        if (result.isDone) {
          this.onReset()
        }
        return result
      }
    },
    async onPublicData(item) {
      let confirm = new ConfirmBuilder()
      confirm
        .addMessage(
          'Dữ liệu ' +
          item.name +
          ' sẽ được công khai và hiển thị trên trang chủ!'
        )
        .setTitle('Công khai dữ liệu')
        .setType('update')
      if (await confirm.confirm()) {
        const result = await API_LAYER.publicLayer(item.id, {
          type: 'layerGroup',
        })
        if (result.isDone) {
          this.onReset()
        }
        return result
      }
    },

    onCreateItem() {
      this.$emit('click:add-map', {})
    },
    onUpdateItem(item) {
      this.$emit('click:add-map', { item, type: EDIT_TYPE.UPDATE })
    },
    onReset() {
      this.$refs.table.reload()
    },
    onPreview(layers) {
      if (!layers || layers.length < 1) return
      this.$router.push({
        name: 'map',
        query: { map_ids: layers.map((x) => x.id).join(',') },
      })
    },
  },
}
</script>
